<template>
  <Card>
    <div slot="body">
      <h4 class="mb-2">🚚 กำลังสร้างออเดอร์</h4>
      <div class="text-center my-4">
        <div style="font-size: 3rem;" class="mb-2">⏳</div>
        <div style="font-size: 1rem;" class="text-muted">กรุณารอสักครู่</div>
      </div>

      <!-- Progress Bar -->
      <div class="progress mb-3" style="height: 20px;">
        <div 
          class="progress-bar progress-bar-striped progress-bar-animated" 
          role="progressbar" 
          :style="{ width: progress + '%' }"
          :aria-valuenow="progress" 
          aria-valuemin="0" 
          aria-valuemax="100"
        >
          {{ progress }}%
        </div>
      </div>

      <div class="text-center text-muted">
        {{ progressText }}
      </div>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/core/Card";

export default {
  name: "CreatingOrdersScreen",
  components: { Card },
  props: {
    progress: {
      type: Number,
      default: 0
    },
    progressText: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
